import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('OutgoingPrepaymentService', OutgoingPrepaymentService);

  OutgoingPrepaymentService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'WindowModalService',
  ];

  function OutgoingPrepaymentService(
    RestResource,
    CONFIG,
    $translate,
    $filter,
    UtilService,
    SessionService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrlPrepayment = environment.apiEndpoint + 'outgoing_prepayments';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getPrepayments: getPrepayments,
      saveOutgoingPrepayment: saveOutgoingPrepayment,
      deleteOutgoingPrepayment: deleteOutgoingPrepayment,
      getProviderPaymentDocumentsPrepayment: getProviderPaymentDocumentsPrepayment,
      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
    };

    return service;

    ///////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'date',
      };

      return filter;
    }

    function getPrepayments(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrlPrepayment,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
              stats: response.meta.stats,
            };
          } else {
            return {
              items: response,
            };
          }
        },
        function () {
          return {
            items: [],
            totalItems: 0,
            entryLimit: 0,
            totalPages: 0,
            stats: [],
          };
        }
      );
    }

    function saveOutgoingPrepayment(outgoingPrepayment, type = 'request') {
      var url = apiUrlPrepayment;
      var method = 'post';

      if (outgoingPrepayment.id) {
        // edit
        url += '/' + outgoingPrepayment.id;
        method = 'put';
      }

      var lang = CONFIG.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        if (type === 'request') {
          var msg = !outgoingPrepayment.id
            ? 'OUTGOING_PREPAYMENT_CREATED'
            : 'OUTGOING_PREPAYMENT_MODIFIED';
          utils._successMsg($translate(msg));
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { outgoing_prepayment: outgoingPrepayment, lang: lang },
        success,
        failure
      );
    }

    function deleteOutgoingPrepayment(outgoingPrepayment, successCallback) {
      let params = {
        title: 'DELETE_OUTGOING_PREPAYMENT',
        itemName: outgoingPrepayment.outgoing_consecutive,
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'DELETED_OUTGOING_PREPAYMENT',
        company_id: outgoingPrepayment.company_id,
      };

      let url = apiUrlPrepayment + '/' + outgoingPrepayment.id;
      utils.deleteItem(url, successCallback, params);
    }

    function getProviderPaymentDocumentsPrepayment(id, params) {
      if (!params) {
        params = {};
      }

      return RestResource.request(
        'get',
        apiUrlPrepayment + '/' + id + '/get_payment_provider_documents',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }

    function openRelatedTransactions(transaction) {
      let templateUrl =
        'prepayment-reports/outgoing-prepayments/modals/outgoing-prepayment-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, companyId) {
      const params = {
        skip_check_role: true,
        company_id: companyId,
      };

      return RestResource.request(
        'get',
        `${apiUrlPrepayment}/${id}/related_transaction/`,
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
